import { checkIfDressingIngredient } from './check-if-dressing-ingredient';

import type { Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function resetDressingQuantity(modification: Modification): Modification {
  const isDressingIngredient = checkIfDressingIngredient(modification);

  if (!isDressingIngredient) {
    return modification;
  }

  return { ...modification, quantity: 1 };
}
